import { useMutation } from "@tanstack/react-query";
import { useAlert } from "context/alert";
import React, { useState } from "react";
import {
  UpdatePasswordForFranchise,
  UpdatePasswordForEmployee,
  UpdatePasswordForAgent,
} from "services/resetPassword";

const ResetPassword = ({
  onClose,
  rowData,
  passwordLabel = "Password",
  confirmPasswordLabel = "Confirm Password",
  successMessage = "Reset Password Successfully",
  errorMessage = "Something went wrong!",
}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const { showAlert } = useAlert();

  const EmployeeCodeId = localStorage.getItem("employee_code_id");

  const onSuccess = () => {
    showAlert(successMessage);
    onClose();
  };

  const onError = () => {
    showAlert(errorMessage, "danger");
  };

  const { mutate: addResetPasswordMutateForFranchise } = useMutation({
    mutationFn: UpdatePasswordForFranchise,
    onSuccess,
    onError,
  });

  const { mutate: addResetPasswordMutateForEmployee } = useMutation({
    mutationFn: UpdatePasswordForEmployee,
    onSuccess,
    onError,
  });

  const { mutate: addResetPasswordMutateForAgent } = useMutation({
    mutationFn: UpdatePasswordForAgent,
    onSuccess,
    onError,
  });

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setError("");

    const payload = { password };
    if (rowData) {
      if (rowData.franchise_id) {
        addResetPasswordMutateForFranchise({
          ...payload,
          franchise_id: rowData.franchise_id,
        });
      } else if (rowData.employee_code_id) {
        addResetPasswordMutateForEmployee({
          ...payload,
          employee_code_id: Number(rowData.employee_code_id),
        });
      } else if (rowData.id) {
        addResetPasswordMutateForAgent({
          ...payload,
          id: Number(rowData.id),
        });
      }
    } else {
      addResetPasswordMutateForEmployee({
        ...payload,
        employee_code_id: Number(EmployeeCodeId),
      });
    }
  };

  return (
    <form onSubmit={handleResetPassword}>
      <div className="mb-3">
        <label htmlFor="password" className="form-label">
          {passwordLabel}
        </label>
        <input
          type="password"
          className="form-control"
          id="password"
          name="password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="confirmPassword" className="form-label">
          {confirmPasswordLabel}
        </label>
        <input
          type="password"
          className="form-control"
          id="confirmPassword"
          name="confirmPassword"
          placeholder="Confirm your password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </div>
      {error && <div className="text-danger mb-3">{error}</div>}
      <button
        type="submit"
        className="btn btn-primary"
        disabled={!password || !confirmPassword}
      >
        Reset Password
      </button>
    </form>
  );
};

export default ResetPassword;
